import app from 'flarum/forum/app';
import Component, { ComponentAttrs } from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import avatar from 'flarum/common/helpers/avatar';
import icon from 'flarum/common/helpers/icon';
import fullTime from 'flarum/common/helpers/fullTime';
import { truncate } from 'flarum/common/utils/string';
import Link from 'flarum/common/components/Link';
import { slug } from '../../common';
import type ScheduledPostListState from '../states/ScheduledPostListState';
import type ScheduledPost from '../models/ScheduledPost';

export interface IScheduledPostsListAttrs extends ComponentAttrs {
	state: ScheduledPostListState;
}

export default class ScheduledPostsList<CustomAttrs extends IScheduledPostsListAttrs = IScheduledPostsListAttrs> extends Component<CustomAttrs> {
	view() {
		const scheduledPosts = app.store.all<ScheduledPost>('scheduled_posts');
		const { state } = this.attrs;

		return (
			<div className="NotificationList ScheduledPostsList">
				<div className="NotificationList-header">
					<h4 className="App-titleControl App-titleControl--text">{app.translator.trans(`${slug}.forum.dropdown.title`)}</h4>
				</div>
				<div className="NotificationList-content">
					<ul className="NotificationGroup-content">
						{!!scheduledPosts.length &&
							scheduledPosts.map((post) => (
								<li>
									<Link href={app.route.discussion(post, 0)} className="Notification ScheduledPostsList-item">
										{avatar(post.user() || null)}

										<span className="Notification-title">
											<div>
												{icon('fas fa-clock', {
													className: 'Notification-icon',
												})}{' '}
												{post.scheduledAt() && fullTime(post.scheduledAt()!)}
											</div>
											<span className="Notification-content">{post.title()}</span>
										</span>
										<div className="Notification-excerpt">{truncate(post.content(), 200)}</div>
									</Link>
								</li>
							))}

						{state.loading ? (
							<LoadingIndicator className="LoadingIndicator--block" />
						) : (
							!scheduledPosts.length && <div className="NotificationsList--empty">{app.translator.trans(`${slug}.forum.dropdown.empty_text`)}</div>
						)}
					</ul>
				</div>
			</div>
		);
	}
}
